<template>
  <div>{{ $t(`tips.tip68`) }}</div>
</template>
<script>
import { useRoute } from "vue-router";
import { defineComponent, onMounted } from "vue";
export default defineComponent({
  setup() {
    const route = useRoute();
    onMounted(() => {
      if (route.query.code) {
        localStorage.setItem("code", route.query.code);
        setTimeout(() => {
          window.close();
        }, 2000);
      }
    });
  },
});
</script>
